import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";
import { Provider } from "react-redux";
import "./styles/reset.css";
import Main from "./main";
import {BrowserRouter as Router,Switch,Route,Link} from "react-router-dom";

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path="/" exact={true}>
          {/* <Main /> */}
          <App />
          </Route>
        <Route path="/App" exact={true} >
          <App/>
        </Route>
        </Switch>
     
    </Router>
    {/* <Main/> */}
    {/* <App /> */}
  </Provider>,
  document.getElementById("root")
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
